import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { fadeInAnimation } from 'app/animations';
import { ActiveCustomerService } from 'app/core/services/active-customer.service';
import { BlankReceipt, BlankReceiptRequest } from 'app/core/store/blank-receipts/blank-receipts.interface';
import { Definition } from 'app/core/store/definitions/definition.interface';
import { Definitions } from 'app/core/store/definitions/definitions.interface';
import { SessionState } from 'app/core/store/session/session.interface';
import { Customer } from 'app/core/store/session/user-context/user-context.interface';
import * as fromRoot from '../../../core/store';
import * as actions from '../../../core/store/blank-receipts/blank-receipts.actions';
import { BaseContainer } from '../../base/BaseContainer';
import { distinctUntilChanged, map, takeWhile } from 'rxjs/operators';

@Component({
  selector: 'app-blank-receipt-page',
  templateUrl: './blank-receipt-page.container.html',
  styleUrls: ['./blank-receipt-page.container.scss'],
  animations: [fadeInAnimation],
})
export class BlankReceiptPageContainer extends BaseContainer {
  blankReceipt: BlankReceipt;
  globalTypes: Definition[];
  shipTos: Definition[] = [];
  customers: Customer[] = null;

  isSaving: boolean = false;
  isSuperUser: boolean = false;

  private selectedCustomer: Customer = null;

  constructor(private activeCustomerService: ActiveCustomerService) {
    super();

    this.store
      .select('definitions')
      .pipe(takeWhile(() => !this.destroyed))
      .subscribe((definitions: Definitions) => {
        this.globalTypes = definitions.global.type;
      });

    this.store
      .select('session')
      .pipe(
        takeWhile(() => !this.destroyed),
        map((session: SessionState) => ({
          isSuperUser: session.userContext.isSuperUser,
          selectedCustomer: session.selectedCustomer.data,
          customers: session.customerPermissions.data.blankReceipts,
        })),
        distinctUntilChanged()
      )
      .subscribe(({ isSuperUser, selectedCustomer, customers }) => {
        this.isSuperUser = isSuperUser;
        if (this.isSuperUser) {
          this.customers = customers;
        } else {
          this.customers = [selectedCustomer];
        }
      });

    this.store
      .select('blankReceipts')
      .pipe(takeWhile(() => !this.destroyed))
      .subscribe((blankReceipt: BlankReceipt) => {
        this.blankReceipt = blankReceipt;
        this.shipTos = blankReceipt.shipTos;
        this.isSaving = blankReceipt.saving;
      });
  }

  createBlankReceipts(request: BlankReceiptRequest) {
    this.store.dispatch(new actions.BlankReceiptCreateAction({ request }));
  }

  async getsShipTosForCustomer(customerId: string) {
    const customer = this.customers.find(c => c.id === customerId);
    if (customer) {
      if (this.selectedCustomer?.id !== customerId) {
        await this.activeCustomerService.setActiveCustomer(customer);
        this.store.dispatch(new actions.BlankReceiptLocationAction({ customer }));
      } else {
        // shipTos are the same, but component already shows spinner and waits update of array, so clone array
        this.shipTos = [...this.shipTos];
      }
    } else {
      this.shipTos = [];
    }
    this.selectedCustomer = customer;
  }
}
